import type { QueryStatusOverviewViewProps } from "@/domains/diagnostics/types"
import { Card } from "@/components/card"

export const QueryStatusOverviewView = ({ data }: QueryStatusOverviewViewProps) => {
  return (
    <Card.Container>
      <h3 className="mb-4 text-lg font-semibold text-t100">Query Status Overview</h3>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 rounded-full bg-blue-400"></div>
          <div>
            <div className="text-sm text-t200">Total Queries</div>
            <div className="text-lg font-semibold text-t100">{data.totalQueries}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 rounded-full bg-green-400"></div>
          <div>
            <div className="text-sm text-t200">Active Queries</div>
            <div className="text-lg font-semibold text-t100">{data.activeQueries}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 rounded-full bg-blue-400"></div>
          <div>
            <div className="text-sm text-t200">Running Queries</div>
            <div className="text-lg font-semibold text-t100">{data.runningQueries}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 rounded-full bg-red-400"></div>
          <div>
            <div className="text-sm text-t200">Error Queries</div>
            <div className="text-lg font-semibold text-t100">{data.errorQueries}</div>
          </div>
        </div>
      </div>
    </Card.Container>
  )
}
